import type { ReactNode } from 'react';

/** The clinic page frame: one teal shell from the logo bar through the step bar, then the work column. */
export function ClinicLayout({
  nav,
  compactMobile = false,
  children,
}: {
  nav?: ReactNode;
  compactMobile?: boolean;
  children: ReactNode;
}) {
  return (
    <div className="bg-canvas text-body selection:bg-gold selection:text-ink flex min-h-dvh flex-col">
      <header className="bg-deep-dark px-4 py-3 sm:px-7">
        <img
          src="/clinic/ftlo-logo-white.webp"
          alt="FTLO Volleyball"
          width={56}
          height={36}
          className="h-9 w-auto"
        />
      </header>
      <ClinicHero compactMobile={compactMobile} />
      {nav}
      <main className="mx-auto flex w-full max-w-2xl flex-1 flex-col gap-5 px-4 pt-6 pb-16 sm:pt-10">
        {children}
      </main>
    </div>
  );
}

function ClinicHero({ compactMobile }: { compactMobile: boolean }) {
  return (
    <section
      aria-labelledby="clinic-title"
      className={`bg-deep bg-[url(/clinic/hero-photo.webp)] bg-cover bg-center px-4 pt-40 pb-6 sm:py-12 ${compactMobile ? 'max-sm:bg-none max-sm:py-0' : ''}`}
    >
      <div
        className={`bg-deep/90 mx-auto flex max-w-2xl flex-col gap-3 rounded-xl px-5 py-6 text-white sm:px-8 sm:py-8 ${compactMobile ? 'max-sm:px-0 max-sm:py-4' : ''}`}
      >
        <h1
          id="clinic-title"
          className="font-display text-2xl leading-tight font-bold tracking-wide text-balance uppercase sm:text-3xl"
        >
          Winter 2027 Clinics <span className="text-brand">Application</span>
        </h1>
        <div className={compactMobile ? 'hidden sm:contents' : 'contents'}>
          <p className="text-on-deep-muted text-sm font-semibold">
            Winter 2027 Term · Adults 18+
          </p>
          <p className="max-w-prose text-base leading-relaxed text-white/90">
            Get ready for Winter 2027 volleyball training with FTLO. Explore
            Beginner, Foundation Focus, and Intermediate clinics below. Program
            dates, locations, fees, and availability will be confirmed before
            registration opens.
          </p>
          <p className="max-w-prose text-base leading-relaxed text-white/90">
            <strong className="text-brand font-semibold">
              This is an application, not a confirmed spot.
            </strong>{' '}
            FTLO will follow up by email with a payment invite once your spot is
            confirmed.
          </p>
        </div>
      </div>
    </section>
  );
}
